import script from "./SkillPclanguageEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillPclanguageEditView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillPclanguageEditView.vue?vue&type=style&index=0&id=4c472dec&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c472dec"]])

export default __exports__